import {useState} from 'react';

import ArchivedNotificationList from '@/pages/speculators/notifications/components/ArchivedNotifications';
import NotificationsList from '@/pages/speculators/notifications/components/NotificationsList';

import {useNotifications} from '@/providers/components/notificationsProvider';

import Button from '@/components/Button';
import Page from '@/components/Page';

export default function NotificationsPage() {
  const {unreadCount, markAllAsRead, archiveAllNotifications} = useNotifications();

  // State
  const [activeTab, setActiveTab] = useState<'active' | 'archived'>('active');

  return (
    <Page currentPage="Notifications">
      <div className="mb-8 flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-white">Notifications</h1>
          {activeTab === 'active' && unreadCount > 0 && (
            <p className="mt-1 text-sm text-gray-400">You have {unreadCount} unread notifications</p>
          )}
        </div>
        <div className="flex items-center gap-4">
          {activeTab === 'active' && (
            <>
              <span className="text-sm text-gray-400">Mark all as:</span>
              <Button onClick={markAllAsRead} color="secondary" icon="bell-off">
                Read
              </Button>
              <Button onClick={markAllAsRead} color="warning" icon="bell-plus">
                Unread
              </Button>
              <Button onClick={archiveAllNotifications} color="danger" icon="archive">
                Archive All
              </Button>
            </>
          )}
        </div>
      </div>

      <div className="mb-6 flex items-center gap-4 border-b border-gray-700">
        <button
          onClick={() => setActiveTab('active')}
          className={`border-b-2 px-4 py-2 text-sm font-medium ${
            activeTab === 'active'
              ? 'border-primary text-primary'
              : 'border-transparent text-gray-400 hover:text-gray-300'
          }`}
        >
          Active
        </button>
        <button
          onClick={() => setActiveTab('archived')}
          className={`border-b-2 px-4 py-2 text-sm font-medium ${
            activeTab === 'archived'
              ? 'border-primary text-primary'
              : 'border-transparent text-gray-400 hover:text-gray-300'
          }`}
        >
          Archived
        </button>
      </div>

      {activeTab === 'archived' ? <ArchivedNotificationList /> : <NotificationsList />}
    </Page>
  );
}
